import { ApiEndpoints } from "@shared/api/api-endpoints";

import { authApiClient, onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import { Utility, UtilityResponse } from "./types";
// Add your feature-specific API calls here
export const coreApi = {
  getUtility: async (tenantId: string): Promise<Utility[]> => {
    if (!tenantId) {
      return [];
    }
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "get-utility",
      (qs) => {
        qs.push("tenant_id", tenantId.toString());
      }
    );
    const response = await authApiClient.get<UtilityResponse>(url);
    return response.data.result;
  },

    getUserRolePermissionAccess: async (utilityId: string): Promise<any> => {
  console.log("getting the utility id at the level of API of use permission", utilityId);

  if (!utilityId) {
    return Promise.reject(new Error("Utility ID missing — cannot fetch permissions"));
  }

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "auth",
    "user-permissions",
    (qs) => {
      qs.push("utility_id", utilityId.toString());
    }
  );

  const response = await onboardingApiClient.get<any>(url);
  return response.data.result;
},

  getSessions: async (): Promise<any> => {
  const token = localStorage.getItem("auth_token");

  if (!token) {
    console.warn("No auth token found — skipping getSessions API call.");
    return []; // or null, depending on what your UI expects
  }

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "auth",
    "auth/sessions"
  );

  const response = await authApiClient.get(url);
  return response.data.sessions;
},

  deleteSessions: async (sessionId?: string | number): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "auth/sessions"
    );
    const response = await authApiClient.delete(url, {
      data: {
        id: sessionId,
      },
    });
    return response.data.sessions;
  },

  deleteAllSessions: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "auth/sessions"
    );
    const response = await authApiClient.delete(url);

    return response.data.sessions;
  },
};
